<template>
  <div
    :class="{
      'dropdown-divider': true,
    }"
  ></div>
</template>
